import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { decorateWith, withName } from 'helpers/decorator';
import { ga } from 'helpers/multitrack';
import { LocationInputField } from 'components/FormFields/LocationInputField';
import { LocationFormValidator } from './LocationFormValidator';
import { updateLocation } from './location.saga';
var messages = defineMessages({
  location: {
    id: 'location-modal.location',
    defaultMessage: 'City name'
  }
});
export var LocationForm =
/*#__PURE__*/
function (_Component) {
  _inherits(LocationForm, _Component);

  function LocationForm() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LocationForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LocationForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleFormSubmit", function (_ref) {
      var location = _ref.location;
      var _this$props = _this.props,
          onLocationRequest = _this$props.onLocationRequest,
          onFormSubmit = _this$props.onFormSubmit;
      onLocationRequest(location);

      if (onFormSubmit) {
        onFormSubmit(location);
      }
    });

    return _this;
  }

  _createClass(LocationForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      ga('Geo_Detection_Modal', 'viewed_modal', '', 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var handleSubmit = this.props.handleSubmit;
      return React.createElement("div", {
        className: "location-modal--location-form"
      }, React.createElement("h2", {
        className: "location-modal__title"
      }, React.createElement(FormattedMessage, {
        id: "location-modal.location-header",
        defaultMessage: "Where do you work out?"
      })), React.createElement("form", {
        onSubmit: handleSubmit(this.handleFormSubmit),
        action: "_self"
      }, React.createElement("div", {
        className: "grid"
      }, React.createElement("div", {
        className: "grid__item 1/1"
      }, React.createElement(FormattedMessage, messages.location, function (placeholder) {
        return React.createElement(Field, {
          component: LocationInputField,
          format: null,
          name: "location",
          inputAttributes: {
            placeholder: placeholder
          }
        });
      })), React.createElement("div", {
        className: "grid__item 1/1"
      }, React.createElement("button", {
        type: "submit",
        className: "bt bt--primary bt--width-full"
      }, React.createElement(FormattedMessage, {
        id: "location-modal.submit",
        defaultMessage: "Submit"
      }))))));
    }
  }]);

  return LocationForm;
}(Component);
LocationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onFormSubmit: PropTypes.func,
  onLocationRequest: PropTypes.func.isRequired
};
var formConfig = {
  form: 'locateUser',
  validate: LocationFormValidator
};
export var mapDispatchToProps = {
  onLocationRequest: updateLocation
};
export var LocationFormContainer = decorateWith(reduxForm(formConfig), withName('LocationForm'), connect(null, mapDispatchToProps))(LocationForm);